import React, { useEffect, useRef, useState } from "react";
import { isChildElement } from "../../utils/isChildElement";
import './Chat.css';

interface IChatProps{
    messages: {text: string, isMine: boolean}[];
}

export const Chat = ({messages}: IChatProps)=>{
    const [isOpened, setOpened] = useState(true);
    const chatRef = useRef<HTMLDivElement>(null);

    const handleSend= (index: number) => ()=>{
        
    }

    useEffect(()=>{
        const windowHandler = (e: MouseEvent)=>{
            if (!isChildElement(e.target as HTMLElement, chatRef.current)){
                //setOpened(false);
            }
        }
        window.addEventListener('click', windowHandler);
        return ()=>{
            window.removeEventListener('click', windowHandler);
        }
    }, []);

    return <div ref={chatRef} className={`chatWidget ${isOpened ? 'chatWidget--opened': ''}`}>
        <div className="chatWidget_wrap">
            <div className="chatWidget_header">
                <div className="chatWidget_title">
                    Chat
                </div>
                <div className="button chatWidget_arrow" onClick={()=>setOpened((last)=>!last)}></div>
            </div>
            <div className="chatWidget_drop">
                <div className="chatWidget_drop_content">
                    <div className="chatWidget_typing">
                        <div className="chatWidget_typing_icon">
                        </div>
                        <div className="chatWidget_typing_text">
                            Riska Thakur is Typing..
                        </div>
                    </div>
                    <div className="scroll chatWidget_scroll">
                        <div className="chatWidget_messages">
                            {messages.map((it, i)=>{
                                return <div className={`chatWidget_message ${it.isMine ? 'chatWidget_message--mine' : ''}`}>
                                    <div className="chatWidget_message_avatar"></div>
                                    <div className="chatWidget_message_text">
                                    {it.text}  
                                    </div>
                                </div>
                            })}
                        </div>
                    </div>
                    <div className="chatWidget_inputs">
                        <div className="chatWidget_attach">

                        </div>
                        <div className="chatWidget_input">
                            <textarea className="scroll chatWidget_input_message">

                            </textarea>
                            <div className="button chatWidget_input_send">

                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
}